import type { FC, ReactNode } from "react";
import { Dialog } from "./Dialog";

export interface EntityFormDialogProps {
  title: string;
  show: boolean;
  onCancel: () => void;
  children: ReactNode;
}

/**
 * Thin wrapper around {@link Dialog} for the common entity CRUD modal shell:
 * a titled dialog whose body is a form that renders its own action buttons
 * (hence `hideButtons`). Consolidates the previously duplicated `*Modal`
 * wrappers (DriverModal, CompanyModal, CustomerModal, etc).
 */
export const EntityFormDialog: FC<EntityFormDialogProps> = function ({
  title,
  show,
  onCancel,
  children,
}) {
  return (
    <Dialog
      title={title}
      content={children}
      show={show}
      toggleModal={onCancel}
      hideButtons={true}
    />
  );
};
